export const ALERT_MODAL_INFO = {
  INVALID_DESTINATION: 'invalidDestination',
  MOVE_FORWARD: 'moveForwardWithWarning',
  MOVE_FORWARD_WITH_WARNING: 'moveForwardWithWarning',
};
